"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _reactRouterDom = require("react-router-dom");

var _config = require("../../../utils/config");

var _excluded = ["internalLink", "addSiteUrl", "siteUrlOverride", "to", "ssr", "children"];

var SectionLink = function SectionLink(_ref) {
  var _ref$internalLink = _ref.internalLink,
      internalLink = _ref$internalLink === void 0 ? true : _ref$internalLink,
      _ref$addSiteUrl = _ref.addSiteUrl,
      addSiteUrl = _ref$addSiteUrl === void 0 ? false : _ref$addSiteUrl,
      _ref$siteUrlOverride = _ref.siteUrlOverride,
      siteUrlOverride = _ref$siteUrlOverride === void 0 ? '' : _ref$siteUrlOverride,
      to = _ref.to,
      ssr = _ref.ssr,
      children = _ref.children,
      props = (0, _objectWithoutProperties2.default)(_ref, _excluded);

  if (internalLink) {
    return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, (0, _extends2.default)({
      to: to
    }, props), children);
  } else {
    var url = to;

    if (siteUrlOverride !== '') {
      url = "".concat(siteUrlOverride).concat(to);
    } else {
      if (addSiteUrl) {
        url = ssr ? "".concat((0, _config.getSiteUrl)('', ssr)).concat(to) : "".concat((0, _config.getSiteUrl)()).concat(to);
      }
    }

    return /*#__PURE__*/_react.default.createElement("a", (0, _extends2.default)({
      href: url
    }, props), children);
  }
};

var _default = SectionLink;
exports.default = _default;